import { render, staticRenderFns } from "./ConfirmSurgBlock.vue?vue&type=template&id=0c3899d3&scoped=true"
import script from "./ConfirmSurgBlock.vue?vue&type=script&lang=js"
export * from "./ConfirmSurgBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3899d3",
  null
  
)

export default component.exports